import { render, staticRenderFns } from "./ApplicationScoreItem.vue?vue&type=template&id=68314806&scoped=true&lang=pug&"
import script from "./ApplicationScoreItem.vue?vue&type=script&lang=js&"
export * from "./ApplicationScoreItem.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationScoreItem.vue?vue&type=style&index=0&id=68314806&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68314806",
  null
  
)

/* custom blocks */
import block0 from "./ApplicationScoreItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports